import { render } from "./ReportPdf.vue?vue&type=template&id=20d6793f&scoped=true"
import script from "./ReportPdf.vue?vue&type=script&lang=js"
export * from "./ReportPdf.vue?vue&type=script&lang=js"

import "./ReportPdf.vue?vue&type=style&index=0&id=20d6793f&scoped=true&lang=css"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d6793f"]])

export default __exports__